const DEV_PUBLIC = 'key_Dmr9XiAksEFNrrbVabxUtKw';

const PRODUCTION_PUBLIC = 'key_etguCHVzHVC2ZzTvX5RuQUg';

export const PUBLIC = process.env.NODE_ENV !== 'production' ? DEV_PUBLIC : PRODUCTION_PUBLIC;
